import { render, staticRenderFns } from "./TrafficData.vue?vue&type=template&id=6b3ba5f4&scoped=true&"
import script from "./TrafficData.vue?vue&type=script&lang=js&"
export * from "./TrafficData.vue?vue&type=script&lang=js&"
import style0 from "./TrafficData.vue?vue&type=style&index=0&id=6b3ba5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ba5f4",
  null
  
)

export default component.exports